import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import dayjs from 'dayjs';
import React from "react";
import Date from "./components/Date";
import Number from "./components/Number";
import AmountDetail from "./components/AmountDetail";
import {getClassName} from "../../../../containers/AppPage/Reports/AgedDetail/utils/getClassName";
import {getColSpan} from "../../../../containers/AppPage/Reports/AgedDetail/utils/getColSpan";

function getColumns(props) {
    const {
        reportData,
        selectedColumnKeys = [],
        getSecondColSpan,
        getColClassName,
    } = props;

    const periodLabels = reportData?.report?.period_labels || [];

    const columns = [
        {
            title: t`Date`,
            dataIndex: 'date',
            key: 'date',
            width: 120,
            render: (text, record) => <Date record={record} />,
        },
        {
            title: t`No.`,
            dataIndex: 'number',
            key: 'number',
            width: 120,
            render: (text, record) => <Number record={record} />,
        },
        {
            title: t`Due Date`,
            dataIndex: 'due_date',
            key: 'due_date',
            onCell: record => ({
                colSpan: getSecondColSpan(record.column_type),
                className: getColClassName(record.column_type),
            }),
            render: text => (text ? dayjs(text).format('DD/MM/YYYY') : '-'),
        },
        {
            title: t`Ref No.`,
            dataIndex: 'number2',
            key: 'number2',
            width: 120,
            render: (text, record) => record.number2 || '-',
        },
        {
            title: t`Description`,
            dataIndex: 'description',
            key: 'description',
            width: 200,
            render: (text, record) => record.description || '-',
        },
        {
            title: t`Title`,
            dataIndex: 'title',
            key: 'title',
            width: 200,
            render: (text, record) => record.title || '-',
        },
        {
            title: t`Current`,
            dataIndex: 'base_coming_due_amount',
            key: 'base_coming_due_amount',
            align: 'right',
            sorter: true,
            render: (text, record) => <AmountDetail
                rowType={record.rowType}
                amount={record.coming_due_amount}
                baseAmount={record.base_coming_due_amount}
                currencySymbol={record.currency_symbol}
            />,
        },
        ...periodLabels.map((item, idx) => ({
            title: item,
            dataIndex: `base_period${idx}_amount`,
            key: `base_period${idx}_amount`,
            align: 'right',
            sorter: true,
            render: (text, record) => <AmountDetail
                rowType={record.rowType}
                amount={record.period_amounts?.[idx] || 0}
                baseAmount={record.base_period_amounts?.[idx] || 0}
                currencySymbol={record.currency_symbol}
            />,
        })),
        {
            title: t`Total `,
            dataIndex: 'base_total_amount',
            key: 'total',
            align: 'right',
            sorter: true,
            render: (text, record) => <AmountDetail
                rowType={record.rowType}
                amount={record.total_amount || 0}
                baseAmount={record.base_total_amount || 0}
                currencySymbol={record.currency_symbol}
            />,
        },
    ];

    const selectedColumnKeysWithPeriods = (
        columns
            .filter(col => selectedColumnKeys.includes(col.key) || col.key.startsWith('base_period'))
            .map(col => col.key)
    );

    return columns.map(col => ({
        ...col,
        onCell: record => ({
            colSpan: getColSpan(record.rowType, col.key, selectedColumnKeysWithPeriods),
            className: getClassName(record.rowType, col.key),
        }),
    }));
}

export default {
    storageKey: StorageKey.report_aging_details_receivable,
    getReportLabel: () => t`Aged Receivables Detail`,
    required: [
        'date',
        'number',
        'base_coming_due_amount',
        'total',
    ],
    getColumns,
};
